export type ThemeName = 'lemon' | 'numerama' | 'frandroid';

export const THEME: ThemeName = (import.meta.env.VITE_THEME as ThemeName) || 'lemon';
